import React, { lazy, Suspense } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import MainLayout from 'layout/MainLayout';


const NotFoundDialog = () => (
  <div className="bg-white border border-red p3 red border-radius-sm flex-row flex-y-start">
    <div className="fas fa-exclamation-circle mr-2" style={{ fontSize: '42px' }} />
    <div>
      <div className="h3">404 Page Not Found</div>
      <div className="span mt-1">Sorry, the page you are looking for is not available.</div>
    </div>
  </div>
);

const Dashboard = lazy(() => import('pages/dashboard'));
const Campaigns = lazy(() => import('pages/campaigns'));
const Products = lazy(() => import('pages/products'));
const Partners = lazy(() => import('pages/partners'));
const Categories = lazy(() => import('pages/categories'));
const Tags = lazy(() => import('pages/tags'));
const UploadFiles = lazy(() => import('pages/uploadFiles'));
const Employees = lazy(() => import('pages/employees'));
const Suppliers = lazy(() => import('pages/suppliers'));
const SalesReport = lazy(() => import('pages/salesReport'));
const Companies = lazy(() => import('pages/companies'));
const Coupons = lazy(() => import('pages/coupons'));
const Shipping = lazy(() => import('pages/shipping'));
const Refund = lazy(() => import('pages/refund'));
const Events = lazy(() => import('pages/events'));
const AccountManagement = lazy(() => import('pages/accountManagement'));
const Orders = lazy(() => import('pages/orders'));
const Invoices = lazy(() => import('pages/invoices'));
const CompanyGroups = lazy(() => import('pages/companyGroups'));
const Perks = lazy(() => import('pages/perks'));
const PerkVendors = lazy(() => import('pages/perkVendors'));
const HeroBanners = lazy(() => import('pages/heroBanners'));
const PageSettings = lazy(() => import('pages/pageSettings'));
const Socials = lazy(() => import('pages/socials'));

export default ({ setLocalToken }) => (
  <MainLayout setLocalToken={setLocalToken}>
    <Suspense fallback={<div className="width-100vh height-100vh flex-x-center flex-row"></div>}>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
        <Route exact path="/dashboard" component={Dashboard} />
        <Route path="/campaigns" component={Campaigns} />
        <Route path="/partners" component={Partners} />
        <Route path="/products" component={Products} />
        <Route path="/categories" component={Categories} />
        <Route path="/tags" component={Tags} />
        <Route path="/employees" component={Employees} />
        <Route path="/suppliers" component={Suppliers} />
        <Route path="/upload" component={UploadFiles} />
        <Route path="/sales_report" component={SalesReport} />
        <Route path="/companies" component={Companies} />
        <Route path="/coupons" component={Coupons} />
        <Route path="/shipping" component={Shipping} />
        <Route path="/refund" component={Refund} />
        <Route path="/events" component={Events} />
        <Route path="/account_management" component={AccountManagement} />
        <Route path="/orders" component={Orders}/>
        <Route path="/invoices" component={Invoices}/>
        <Route path="/pricing_tiers" component={CompanyGroups} />
        <Route path="/perks" component={Perks} />
        <Route path="/perk_vendors" component={PerkVendors} />
        <Route path="/hero_banners" component={HeroBanners} />
        <Route path="/page_settings" component={PageSettings} />
        <Route path="/socials" component={Socials} />

        <Route component={NotFoundDialog} />
      </Switch>
    </Suspense>
  </MainLayout>
);
